/**
 * Same balance-summary rules as the former server endpoint (removed); uses bootstrap data from GET /assets/full/.
 * filters: { asset?: number|string, category_code?: string, location_name?: string }
 */

function round2(n) {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

function itemMarketValue(item) {
  const muv = item.market_unitary_value != null ? parseFloat(item.market_unitary_value) : null;
  if (muv != null && !Number.isNaN(muv) && muv !== 0) {
    const qtyRaw = item.snapshot_quantity != null ? parseFloat(item.snapshot_quantity) : 1;
    const qty = Number.isNaN(qtyRaw) ? 1 : qtyRaw;
    return qty * muv;
  }
  return parseFloat(item.snapshot_value) || 0;
}

export function computeAssetBalanceSummary(
  { snapshots = [], snapshot_items = [], assets = [] },
  filters = {}
) {
  const assetsById = {};
  (assets || []).forEach((a) => {
    assetsById[a.id] = a;
  });

  const passesItemFilters = (item) => {
    const ast = assetsById[item.asset];
    if (!ast) return false;
    if (filters.asset != null && filters.asset !== '' && Number(item.asset) !== Number(filters.asset)) {
      return false;
    }
    if (filters.category_code && ast.category_code !== filters.category_code) return false;
    if (
      filters.location_name != null &&
      filters.location_name !== '' &&
      (ast.location_name || '') !== filters.location_name
    ) {
      return false;
    }
    return true;
  };

  const closingSnapshots = (snapshots || [])
    .filter((s) => s.is_closing)
    .sort((a, b) => (b.snapshot_date || '').localeCompare(a.snapshot_date || ''));
  const latest = closingSnapshots[0] || null;

  if (!latest) {
    return {
      latest_snapshot: null,
      total_patrimony: 0,
      total_market_patrimony: 0,
      by_category: [],
      history: [],
    };
  }

  const itemsLatest = (snapshot_items || []).filter(
    (i) => i.snapshot === latest.id && passesItemFilters(i)
  );

  let totalPatrimony = 0;
  let totalMarketPatrimony = 0;
  const categoryTotals = {};

  itemsLatest.forEach((item) => {
    const sv = parseFloat(item.snapshot_value) || 0;
    const mv = itemMarketValue(item);
    totalPatrimony += sv;
    totalMarketPatrimony += mv;
    const ast = assetsById[item.asset];
    const code = ast?.category_code ?? '';
    categoryTotals[code] = (categoryTotals[code] || 0) + sv;
  });

  const by_category = Object.entries(categoryTotals)
    .map(([category_code, total]) => ({ category_code, total: round2(total) }))
    .sort((a, b) => b.total - a.total);

  const historyRows = [...(snapshots || []).filter((s) => s.is_closing)].sort((a, b) =>
    (a.snapshot_date || '').localeCompare(b.snapshot_date || '')
  );

  const snapshotTotals = {};
  const marketTotals = {};
  (snapshot_items || []).forEach((item) => {
    if (!passesItemFilters(item)) return;
    const sid = item.snapshot;
    if (snapshotTotals[sid] === undefined) {
      snapshotTotals[sid] = 0;
      marketTotals[sid] = 0;
    }
    snapshotTotals[sid] += parseFloat(item.snapshot_value) || 0;
    marketTotals[sid] += itemMarketValue(item);
  });

  const history = historyRows.map((row) => ({
    snapshot_id: row.id,
    snapshot_date: row.snapshot_date,
    total: round2(snapshotTotals[row.id] || 0),
    total_market: round2(marketTotals[row.id] || 0),
  }));

  return {
    latest_snapshot: {
      id: latest.id,
      snapshot_date: latest.snapshot_date,
      is_closing: latest.is_closing,
    },
    total_patrimony: round2(totalPatrimony),
    total_market_patrimony: round2(totalMarketPatrimony),
    by_category,
    history,
  };
}
